<template>
  <div>
    <section class="section">
      <div class="container narrow-container">
        <div
          class="has-diffused-shadow has-large-padding-horizontal has-large-padding-vertical has-border-radius-16"
        >
          <p class="is-size-4 has-text-weight-bold has-small-margin-top">
            Subscription and Billing
          </p>
          <p class="is-size-6 has-text-grey">
            Manage your subscription and payment methods using our billing portal.
          </p>
          <div class="has-large-margin-top">
            <subscription-plan-summary />
          </div>
          <div class="has-large-margin-top"></div>
          <div class="has-large-margin-top">
            <p class="is-overline has-margin-bottom">Subscription Usage</p>
            <subscription-usage-chart v-loading="loading" />
          </div>
          <div class="has-margin-top">
            <el-button v-loading="loadingPortal" @click="goToPortal" type="primary">
              Go To Billing Portal
            </el-button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import UserService from '@/api/user.service';
import SubscriptionUsageChart from '@/components/Billing/SubscriptionUsageChart.vue';
import SubscriptionPlanSummary from '@/components/Billing/SubscriptionPlanSummary.vue';
import { PROJECTS_LITE_GET } from '@/store/action-types';

export default {
  name: 'Account',
  components: {
    SubscriptionUsageChart,
    SubscriptionPlanSummary,
  },
  data() {
    return {
      loadingPortal: false,
      loading: true,
    };
  },
  async created() {
    await this.$store.dispatch(PROJECTS_LITE_GET);
    this.loading = false;
  },
  computed: {
    subscription() {
      return this.$store.getters.userSubscription;
    },
    user() {
      return this.$store.state.user;
    },
  },
  methods: {
    async goToPortal() {
      this.loadingPortal = true;
      try {
        const returnURL = `${window.location.origin}${this.$route.path}`;
        const portalSession = await UserService.getPortalSession(this.user._id, returnURL);
        window.location.href = portalSession.url;
      } catch (e) {
        console.log(e);
        this.$message({
          type: 'error',
          message:
            'Something went wrong while directing you to the billing portal. Please refresh your page.',
        });
        this.loadingPortal = false;
      }
    },
  },
};
</script>
